var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAllOptionsIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon all-options-icon",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 3.333a4 4 0 014 4V12a4 4 0 01-4 4H7.583a4 4 0 01-4-4V7.333a4 4 0 014-4h4.667zm-.333 1.334h-4a3 3 0 00-3 3v4a3 3 0 003 3h4a3 3 0 003-3v-4a3 3 0 00-3-3zM8.917 0a4 4 0 013.646 2.353A3.988 3.988 0 0010.917 2H6.25a4 4 0 00-4 4v4.667c0 .587.126 1.144.353 1.646A4 4 0 01.25 8.667V4a4 4 0 014-4h4.667zm3.804 7.529c.24.24.26.618.056.88l-.056.062-3.333 3.334a.667.667 0 01-.88.055l-.063-.055-1.333-1.334a.667.667 0 01.88-.998l.063.056.862.861 2.862-2.861c.26-.26.682-.26.942 0z"
  })));
}

export default SvgAllOptionsIconSv;